import { J1DownarrowD } from '@e3dc-react/icons'
import { FormControl, InputLabel, MenuItem, Select as MuiSelect, SelectProps, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

type BaseSelectProps = {
  options: { value: string | number | boolean; label: string; disabled?: boolean }[]
} & SelectProps

/**
 * Styled MUI Select used directly for non-form scenarios, or wrap with react-hook-form Controller.
 */
export const BaseSelect: React.FC<BaseSelectProps> = ({ options, label, fullWidth, ...props }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const applyFullWidth = fullWidth || downSm

  return (
    <FormControl fullWidth={applyFullWidth}>
      {label && <InputLabel>{label}</InputLabel>}
      <MuiSelect
        sx={{
          '& .MuiSelect-select': {
            paddingBlock: 1.5,
            paddingInline: 2,
          },
        }}
        label={label}
        IconComponent={J1DownarrowD}
        fullWidth={applyFullWidth}
        {...props}
      >
        {options.map(option => (
          <MenuItem key={String(option.value)} value={String(option.value)} disabled={option.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  )
}

BaseSelect.displayName = 'BaseSelect'
